<template>
    <b-card class="card-accent-secondary" header-tag="header" footer-tag="footer" no-body>
        <template v-slot:header>
            <i class="fa-regular fa-weight-scale"></i> <strong> Measurements </strong>
            <div class="card-header-actions">
                <b-link  class="card-header-action" @click="showChart = !showChart">
                    <i class="fa-regular fa-chart-line"></i>
                </b-link>

                <b-link class="card-header-action btn-minimize" @click="visible = !visible">
                    <i class="fa-regular" :class="visible ? 'fa-square-caret-up' : 'fa-square-caret-down'"></i>
                </b-link>
            </div>
        </template>
        <b-collapse v-model="visible">
            <measurements-base borderless :callback="createPatientMeasurements" />
        </b-collapse>

        <measurements-chart v-if="showChart" @close="showChart = false" />
    </b-card>
</template>
<script>
import ComponentExtension from "@/core/components/ComponentExtension"
import MeasurementsBase from './MeasurementsBase'
import Chart from './Chart'
import { mapActions } from "vuex"

export default ComponentExtension.extend({
    name: "measurements",
    components: {
        'measurements-base': MeasurementsBase,
        'measurements-chart': Chart
    },
    data() {
        return {
            showChart: false
        }
    },
    methods: {
        ...mapActions('health', ['createPatientMeasurements'])
    }
})
</script>